import React, { useState } from 'react';
import { alpha, makeStyles } from "@material-ui/core"
import SearchIcon from '@material-ui/icons/Search';
import InputBase from '@material-ui/core/InputBase';
import IconButton from '@material-ui/core/IconButton';
import { useDispatch } from 'react-redux';
import { useHistory } from "react-router-dom"
import { toast } from "react-toastify"
const useStyles = makeStyles((theme) => ({
    search: {
        position: 'relative',
        borderRadius: theme.shape.borderRadius,
        backgroundColor: alpha('#f0f0f0', 1),
        marginLeft: 0,
        width: '100%',
        [theme.breakpoints.up('sm')]: {
            marginLeft: theme.spacing(1),
            width: 'auto',
        },
        "@media(max-width:770px)": {
            display: "none"
        }

    },
    searchIcon: {
        padding: theme.spacing(0, 2),
        height: '100%',
        position: 'relative',
        pointerEvents: 'none',
        display: 'flex',
        //  alignItems: 'center',
        //  justifyContent: 'center',
    },
    inputRoot: {
        color: 'inherit',
    },
    inputInput: {
        padding: theme.spacing(1, 1, 1, 0),
        // vertical padding + font size from searchIcon
        paddingLeft: `calc(2px + ${theme.spacing(1)}px)`,
        transition: theme.transitions.create('width'),
        width: '100%',
        [theme.breakpoints.up('sm')]: {
            width: '12ch',
            '&:focus': {
                width: '20ch',
            },
        },
    },

    selection: {

        backgroundColor: alpha('#f0f0f0', 1),
        border: "none",
        color: "#000",
        fontSize: "14px",
        fontWeight: "bold",
        padding: "0px",
        borderRadius: "6px",
        marginTop: "15px",
    }


}));

const Searchbar = () => {

    const history = useHistory();

    const style = useStyles();
    const dispatch = useDispatch();

    const [search, setSearch] = useState("");
    const [selection, setSelection] = useState("research");
    const [type, setType] = useState(0);

    const onClick = (e) => {

        console.log("search")

        if (search.length < 2) {

            return toast.warning("검색어를 최소 2글자 이상 입력해주세요~!🔍💻")
        }

        if (search.length > 30) {

            return toast.warning("검색어는 30글자까지 입니다~!🔍💻")
        }

        dispatch({
            type: selection,
            payload: {
                content: search,
                type
            }
        })



        history.push("/mysearch")

    }

    const onSelect = (e) => {

        setSelection(e.target.value)

        if (e.target.value === "research") {
            setType(0)
        } else if (e.target.value === "poll") {
            setType(1)
        } else {//content
            setType(2)
        }

    }

    return (
        <div className={style.search}>
            <select className={style.selection} onChange={(e) => { onSelect(e) }}>
                <option value="research" id="0" >리서치</option>
                <option value="poll" id="1">투표</option>
                <option value="content" id="2">콘텐츠</option>
            </select>

            <InputBase
                placeholder="Search…"
                classes={{
                    root: style.inputRoot,
                    input: style.inputInput,
                }}
                inputProps={{ 'aria-label': 'search' }}
                onChange={(e) => setSearch(e.target.value)}
            />
            <IconButton aria-label="search" onClick={(e) => onClick(e)}>
                <SearchIcon />
            </IconButton>

        </div>

    );
};

export default Searchbar;